import { Component } from "react"

import { usRegions, globalRegions } from "shared/imports/regionConstants"

import { RegionFilter, StanceFilter, PriorityFilter } from "shared/search/containers/Filter/Filters"

import { inIssueFilter } from "shared/search/containers/Filter/FilterCreators"

import {
    genericMapScene,
    genericBarPieScene,
    genericLineScene,
} from "search-new/containers/Visualization/VisualizationScene/VisualizationScenes"

import {
    GeneralStatusFilter,
    GlobalStatusFilter,
    GlobalRegionFilter,
    RegulationAgencyPublicOrgSourceFilter,
    RegulationProposedDatePickerStartNoFutureFilter,
    RegulationProposedDatePickerEndNoFutureFilter,
    TypeFilter,
} from "shared/search/containers/Filter/RegulationFilters"

import { worldMapConfig } from "search-new/components/Visualization/VisualizationWrappers/MapConfigs"

export class RegulationTypeBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "regulationTypeBarPieScene",
        filterId: TypeFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "typeFrequency",
        label: "Regulation Types",
        icon: "fa-book",
        sidebarTableLabel: "Regulations by Type",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export const RegulationStanceBarPieScene = (props) => genericBarPieScene(props)
RegulationStanceBarPieScene.defaultProps = {
    uniqueVizSceneId: "regulationStanceBarPieScene",
    filterId: StanceFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "stanceFrequency",
    label: "Stance",
    icon: "fa-thumbs-o-up",
    sidebarTableLabel: "Regulations by Organization Stance",
}

export const RegulationPriorityBarPieScene = (props) => genericBarPieScene(props)
RegulationPriorityBarPieScene.defaultProps = {
    uniqueVizSceneId: "regulationPriorityBarPieScene",
    filterId: PriorityFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "priorityFrequency",
    label: "Priority",
    icon: "fa-arrows-v",
    sidebarTableLabel: "Regulations by Organization Priority",
}

export const RegulationStatusBarPieScene = (props) => genericBarPieScene(props)
RegulationStatusBarPieScene.defaultProps = {
    uniqueVizSceneId: "regulationStatusBarPieScene",
    filterId: GeneralStatusFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "statusFrequency",
    label: "Status",
    icon: "fa-gavel",
    sidebarTableLabel: "Regulations by Status",
}

export const RegulationGlobalStatusBarPieScene = (props) => genericBarPieScene(props)
RegulationGlobalStatusBarPieScene.defaultProps = {
    uniqueVizSceneId: "regulationGlobalStatusBarPieScene",
    filterId: GlobalStatusFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "globalStatusFrequency",
    label: "Status",
    icon: "fa-gavel",
    sidebarTableLabel: "Regulations by Status",
}

export class RegulationTrendsScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "regulationTrendsScene",
        dateStartId: RegulationProposedDatePickerStartNoFutureFilter.defaultProps.uniqueFilterId,
        dateEndId: RegulationProposedDatePickerEndNoFutureFilter.defaultProps.uniqueFilterId,
        label: "Trends",
        icon: "fa-line-chart",
    }

    render() {
        return genericLineScene(this.props)
    }
}

export class RegulationAgencyBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "billCommitteeBarPieScene",
        filterId: RegulationAgencyPublicOrgSourceFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "agencyFrequency",
        label: "Agencies",
        icon: "fa-gavel",
        regions: usRegions,
        sidebarTableLabel: "Agencies",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class RegulationStateBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "regulationStateBarPieScene",
        filterId: RegionFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "stateFrequency",
        label: "States",
        icon: "fa-map-marker",
        regions: usRegions,
        sidebarTableLabel: "Regulations by State",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export const RegulationInIssuesBarPieScene = (props) => genericBarPieScene(props)
RegulationInIssuesBarPieScene.defaultProps = {
    uniqueVizSceneId: "regulationInIssuesBarPieScene",
    filterId: inIssueFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "inIssueFrequency",
    label: "Issues",
    icon: DjangIO.app.models.QuorumDataType.issue_management.icon,
    sidebarTableLabel: "Regulations tagged to Issue",
}

export const RegulationGlobalMapScene = (props) => genericMapScene(props)
RegulationGlobalMapScene.defaultProps = {
    uniqueVizSceneId: "regulationGlobalMapScene",
    filterId: GlobalRegionFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "regionFrequency",
    label: "World Map",
    icon: "fa-globe",
    sidebarTableLabel: "Regulations by Country",
    regions: globalRegions,
    configs: {
        ...worldMapConfig,
        useResourceId: false,
    },
}

/* eslint-enable */
